import { render } from "./BaseButton.vue?vue&type=template&id=70a015da&scoped=true"
const script = {}

import "./BaseButton.vue?vue&type=style&index=0&id=70a015da&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a015da"]])

export default __exports__